import React from 'react';
import {
  Row,
  Col,
  Card,
  Carousel,
} from 'antd';

import PropTypes from 'prop-types';

import { numberDivisions } from '../../helpers/index';

import styles from './StatsCards.module.css';

const SlidingCards = ({ statistic }) => {
  const settings = {
    autoplay: true,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    mobileFirst: true,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 2000,
        settings: 'unslick'
      },
      {
        breakpoint: 1600,
        settings: 'unslick'
      },
      {
        breakpoint: 1024,
        settings: 'unslick'
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <div>
      <Carousel {...settings} className={styles.carousel}>
        <div>
          <Card
            size="small"
            type="inner"
            title="Requests"
            className={styles.card}
          >
            <div className={styles['card-line']}><span className={styles['card-title']}>Total:</span> <span className={styles['card-value']}>{numberDivisions(statistic.ReqCount)}</span></div>
            <div className={styles['card-line']}><span className={styles['card-title']}>Non-empty:</span> <span className={styles['card-value']}>{numberDivisions(statistic.ReqOkCount)}</span></div>
            <div className={styles['card-line']}><span className={styles['card-title']}>Coverage:</span> <span className={styles['card-value']}>{statistic.ReqCov}%</span></div>
          </Card>
        </div>
        <div>
          <Card
            size="small"
            type="inner"
            title="Clicks"
            className={styles.card}
          >
            <div className={styles['card-line']}><span className={styles['card-title']}>Estimated:</span> <span className={styles['card-value']}>{numberDivisions(statistic.estClicks)}</span></div>
            <div className={styles['card-line']}><span className={styles['card-title']}>Verified:</span> <span className={styles['card-value']}>{numberDivisions(statistic.verClicks)}</span></div>
            <div className={styles['card-line']}><span className={styles['card-title']}>Estimated Ctr:</span> <span className={styles['card-value']}>{statistic.estCtr}%</span></div>
          </Card>
        </div>
        <div>
          <Card
            size="small"
            type="inner"
            title="Money"
            className={styles.card}
          >
            <div className={styles['card-line']}><span className={styles['card-title']}>Estimated:</span> <span className={styles['card-value']}>{statistic.estAmount}</span></div>
            <div className={styles['card-line']}><span className={styles['card-title']}>Verified:</span> <span className={styles['card-value']}>{statistic.verAmount}</span></div>
            <div className={styles['card-line']}><span className={styles['card-title']}>Verified Percent:</span> <span className={styles['card-value']}>{statistic.verPerc}%</span></div>
          </Card>
        </div>
        <div>
          <Card
            size="small"
            type="inner"
            title="Avg Bid"
            className={styles.card}
          >
            <div className={styles['card-line']}><span className={styles['card-title']}>Estimated:</span> <span className={styles['card-value']}>{statistic.estBid}</span></div>
            <div className={styles['card-line']}><span className={styles['card-title']}>Verified:</span> <span className={styles['card-value']}>{statistic.verBid}</span></div>
          </Card>
        </div>
      </Carousel>
    </div>
  );
};

const Cards = ({ statistic }) => (
  <div className={styles['cards-wrapper']}>
    <Row gutter={15}>
      <Col
        xs={24}
        md={12}
        lg={6}
        className={styles.col}
      >
        <Card
          size="small"
          type="inner"
          title="Requests"
          className={styles.card}
        >
          <div className={styles['card-line']}><span className={styles['card-title']}>Total:</span> <span className={styles['card-value']}>{numberDivisions(statistic.ReqCount)}</span></div>
          <div className={styles['card-line']}><span className={styles['card-title']}>Non-empty:</span> <span className={styles['card-value']}>{numberDivisions(statistic.ReqOkCount)}</span></div>
          <div className={styles['card-line']}><span className={styles['card-title']}>Coverage:</span> <span className={styles['card-value']}>{statistic.ReqCov}%</span></div>
        </Card>
      </Col>
      <Col
        xs={24}
        md={12}
        lg={6}
        className={styles.col}
      >
        <Card
          size="small"
          type="inner"
          title="Clicks"
          className={styles.card}
        >
          <div className={styles['card-line']}><span className={styles['card-title']}>Estimated:</span> <span className={styles['card-value']}>{numberDivisions(statistic.estClicks)}</span></div>
          <div className={styles['card-line']}><span className={styles['card-title']}>Verified:</span> <span className={styles['card-value']}>{numberDivisions(statistic.verClicks)}</span></div>
          <div className={styles['card-line']}><span className={styles['card-title']}>Estimated Ctr:</span> <span className={styles['card-value']}>{statistic.estCtr}%</span></div>
        </Card>
      </Col>
      <Col
        xs={24}
        md={12}
        lg={6}
        className={styles.col}
      >
        <Card
          size="small"
          type="inner"
          title="Money"
          className={styles.card}
        >
          <div className={styles['card-line']}><span className={styles['card-title']}>Estimated:</span> <span className={styles['card-value']}>{statistic.estAmount}</span></div>
          <div className={styles['card-line']}><span className={styles['card-title']}>Verified:</span> <span className={styles['card-value']}>{statistic.verAmount}</span></div>
          <div className={styles['card-line']}><span className={styles['card-title']}>Verified Percent:</span> <span className={styles['card-value']}>{statistic.verPerc}%</span></div>
        </Card>
      </Col>
      <Col
        xs={24}
        md={12}
        lg={6}
        className={styles.col}
      >
        <Card
          size="small"
          type="inner"
          title="Avg Bid"
          className={styles.card}
        >
          <div className={styles['card-line']}><span className={styles['card-title']}>Estimated:</span> <span className={styles['card-value']}>{statistic.estBid}</span></div>
          <div className={styles['card-line']}><span className={styles['card-title']}>Verified:</span> <span className={styles['card-value']}>{statistic.verBid}</span></div>
        </Card>
      </Col>
    </Row>
  </div>
);

class StatsCards extends React.Component {
  state = {
    width: 0,
    height: 0
  };

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  };

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  };

  updateWindowDimensions = () => {
    this.setState({
      width: window.innerWidth,
      height: window.innerHeight
    });
  };

  render() {
    const { statistic } = this.props;

    let content = this.state.width <= 767
      ? <SlidingCards statistic={statistic} />
      : <Cards statistic={statistic} />;

    return content;
  }

};

StatsCards.propTypes = {
  statistic: PropTypes.oneOfType([
    PropTypes.object.isRequired,
    PropTypes.bool.isRequired,
  ]),
};

export default StatsCards;
